const resources = {
    biFreeShip: 'Les membres Beauty Insider profitent de la *livraison standard {color:red}GRATUITE* sur toutes les commandes{color}.',
    freeShipQualifies: 'Votre commande est admissible à *{Color:Red}la livraison standard GRATUITE.{Color}*'
};

module.exports = function getResource(label) {
    return resources[label];
};
